import React from 'react';
import { motion } from 'framer-motion';
import { Check, Heart, Package } from 'lucide-react';
import { PageTransition } from '../components/PageTransition';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Link } from 'react-router-dom';
export function OutreachPage() {
  return <PageTransition data-id="element-641" data-mp="34hg6cabja0yy">
      <div className="pt-24 pb-16 min-h-screen" data-id="element-642" data-mp="34j0zbvi79bup">
        {/* Hero */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-16 text-center" data-id="element-643" data-mp="2gs51ohr2bmfj">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} data-id="element-644" data-mp="2btaktlcno7y2">
            <div className="mb-8" data-id="element-645" data-mp="2krvwqxnmgopv">
              <img src="https://cdn.magicpatterns.com/uploads/mmGRaZje5gHPYZ1hRf9zTx/operationolivebranch.jpg" alt="Operation Olive Branch" className="w-64 h-auto mx-auto" data-id="element-646" data-mp="2kv1q4p3aacre" />
            </div>
            <span className="text-gold-500 font-medium tracking-wider uppercase mb-2 block" data-id="element-647" data-mp="3nzxqaelvziv">
              Serving the Least of These
            </span>
            <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-648" data-mp="7qo48bfukuco">
              Operation Olive Branch
            </h1>
            <p className="text-xl text-white/80 max-w-3xl mx-auto leading-relaxed" data-id="element-649" data-mp="hn9cd5n5ylkq">
              3 Doves Podcast believes faith without action is incomplete. Our
              Essential Bags program provides homeless individuals with dignity
              and basic necessities — because every person is made in the image
              of God.
            </p>
          </motion.div>
        </div>

        {/* Bags Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-650" data-mp="3uv3zaprzetjw">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-651" data-mp="2xex4mnr8fpx7">
            {/* Men's Bag */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-652" data-mp="32cgk1qzo28qq">
              <Card className="h-full bg-dark-700 border-dark-600 p-8 relative overflow-hidden" data-id="element-653" data-mp="342lnap4bymhv">
                <div className="absolute top-0 right-0 p-4 opacity-10" data-id="element-654" data-mp="2z2z9oeklb48j">
                  <Package size={120} data-id="element-655" data-mp="2bdok7t8oww9p" />
                </div>
                <h3 className="text-2xl font-serif font-bold text-white mb-2" data-id="element-656" data-mp="2be6jyzuk9smd">
                  Men's Essential Bag
                </h3>
                <p className="text-gold-500 mb-6" data-id="element-657" data-mp="2lbuj01z79mac">2-Gallon Care Package</p>

                <ul className="space-y-3 mb-8" data-id="element-658" data-mp="2l9rk0sg2kith">
                  {['Toothpaste & Toothbrush', 'Antibacterial Wipes', 'Body Wipes', 'Dude Wipes', 'Hairbrush', 'Toiletries Kit', 'Water Bottle', 'Snack & Energy Bars'].map((item, i) => <li key={i} className="flex items-center text-white/80" data-id="element-659" data-mp="1ij8jyqabeo8t" data-mpi={i}>
                      <Check className="w-5 h-5 text-gold-500 mr-3 flex-shrink-0" data-id="element-660" data-mp="1ih5h35o2d0mo" />
                      {item}
                    </li>)}
                </ul>
              </Card>
            </motion.div>

            {/* Women's Bag */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-661" data-mp="1x7wd6pwoulvl">
              <Card className="h-full bg-dark-700 border-dark-600 p-8 relative overflow-hidden" data-id="element-662" data-mp="1sgmphuup9smc">
                <div className="absolute top-0 right-0 p-4 opacity-10" data-id="element-663" data-mp="2g6qmvkhaow4w">
                  <Heart size={120} data-id="element-664" data-mp="2kxgul4d71b2r" />
                </div>
                <h3 className="text-2xl font-serif font-bold text-white mb-2" data-id="element-665" data-mp="2kz1piv3f6w15">
                  Women's Essential Bag
                </h3>
                <p className="text-gold-500 mb-6" data-id="element-666" data-mp="rd2wvjrvjx91">2-Gallon Care Package</p>

                <ul className="space-y-3 mb-8" data-id="element-667" data-mp="rexfusjl5fah">
                  {['Toothpaste & Toothbrush', 'Antibacterial Wipes', 'Body Wipes', 'Feminine Hygiene Products', 'Hairbrush', 'Toiletries Kit', 'Water Bottle', 'Snack & Energy Bars'].map((item, i) => <li key={i} className="flex items-center text-white/80" data-id="element-668" data-mp="169k5424rovrd" data-mpi={i}>
                      <Check className="w-5 h-5 text-gold-500 mr-3 flex-shrink-0" data-id="element-669" data-mp="11b0kc51wtq0l" />
                      {item}
                    </li>)}
                </ul>
              </Card>
            </motion.div>
          </div>
        </div>

        {/* Biblical Foundation */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-670" data-mp="1txtneu2rv1dr">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-671" data-mp="21cdpvd1chf37">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-672" data-mp="2fbwv9y2rucbt">
              Biblical Foundation
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto" data-id="element-673" data-mp="2p8i0okipdpg6">
              Our outreach is rooted in Scripture and God's heart for the poor,
              broken, and marginalized.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-674" data-mp="2yyuoqmpq80r2">
            {[{
            title: 'Care for the Poor',
            verse: 'Proverbs 19:17 (NLT)',
            text: '"If you help the poor, you are lending to the Lord—and he will repay you!"'
          }, {
            title: 'God Sees and Provides',
            verse: 'Psalm 146:7 (NLT)',
            text: '"He gives justice to the oppressed and food to the hungry. The Lord frees the prisoners."'
          }, {
            title: 'Shelter and Compassion',
            verse: 'Isaiah 58:7 (NLT)',
            text: '"Share your food with the hungry, and give shelter to the homeless. Give clothes to those who need them…"'
          }, {
            title: 'Jesus Identifies with the Needy',
            verse: 'Matthew 25:35 (NLT)',
            text: '"For I was hungry, and you fed me. I was thirsty, and you gave me a drink. I was a stranger, and you invited me into your home."'
          }, {
            title: 'God is Close to the Broken',
            verse: 'Psalms 34:18 (NLT)',
            text: '"The Lord is close to the brokenhearted; he rescues those whose spirits are crushed."'
          }, {
            title: 'Encouragement for Dignity and Strength',
            verse: 'Philippians 4:13 (NLT)',
            text: '"For I can do everything through Christ, who gives me strength."'
          }].map((scripture, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} data-id="element-675" data-mp="283n8bvbishnf" data-mpi={index}>
                <Card className="h-full bg-dark-700 border-dark-600 p-6" data-id="element-676" data-mp="3firzpnjuml47">
                  <h3 className="text-lg font-serif font-bold text-gold-400 mb-2" data-id="element-677" data-mp="3fjjn4b3alcje">
                    {scripture.title}
                  </h3>
                  <p className="text-xs text-white/50 mb-3 uppercase tracking-wider" data-id="element-678" data-mp="27bjfcqg2ux1f">
                    {scripture.verse}
                  </p>
                  <p className="text-white/80 italic leading-relaxed" data-id="element-679" data-mp="22cp01yhbjqm2">
                    {scripture.text}
                  </p>
                </Card>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-dark-800 rounded-2xl p-8 border border-dark-600" data-id="element-680" data-mp="1sk14t85zlupg">
            <h3 className="text-2xl font-serif font-bold text-white mb-6 text-center" data-id="element-681" data-mp="19nrlo6g8adyl">
              Key Takeaway
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-682" data-mp="38ztxqvmiw628">
              {['God sees them', 'God cares for them', 'God calls others to help them', 'Their situation does not define their worth'].map((point, index) => <div key={index} className="flex items-start" data-id="element-683" data-mp="3ghs7n18m9j5z" data-mpi={index}>
                  <Check className="w-5 h-5 text-gold-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-684" data-mp="3lbwd1g28hj4y" />
                  <p className="text-white/90 font-medium" data-id="element-685" data-mp="3q8mr5xuha4nq">{point}</p>
                </div>)}
            </div>
          </motion.div>
        </div>

        {/* How to Help */}
        <div className="bg-dark-800 py-16 border-y border-dark-600" data-id="element-686" data-mp="2xk8sdfvkf4b4">
          <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-687" data-mp="32k3jnkj95vwp">
            <h2 className="text-3xl font-serif font-bold text-white mb-8" data-id="element-688" data-mp="32iiqnzcl6l0y">
              How You Can Help
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-689" data-mp="37gty63fesjg0">
              <div className="p-6" data-id="element-690" data-mp="htcrewe29bj4">
                <div className="w-12 h-12 bg-gold-500/10 rounded-full flex items-center justify-center mx-auto mb-4 text-gold-500 font-bold text-xl" data-id="element-691" data-mp="msz5f81pqvsz">
                  1
                </div>
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-692" data-mp="1rl8emo0jo5h4">
                  Give Funds
                </h3>
                <p className="text-white/60 text-sm" data-id="element-693" data-mp="21d4hecdksjro">
                  Your financial support purchases supplies in bulk for maximum
                  impact.
                </p>
              </div>
              <div className="p-6" data-id="element-694" data-mp="18ogqo1a2526q">
                <div className="w-12 h-12 bg-gold-500/10 rounded-full flex items-center justify-center mx-auto mb-4 text-gold-500 font-bold text-xl" data-id="element-695" data-mp="18picn0sm3938">
                  2
                </div>
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-696" data-mp="1hntykpij9ipc">Volunteer</h3>
                <p className="text-white/60 text-sm" data-id="element-697" data-mp="1mohrxhu8ibmq">
                  Join us for packing days to assemble bags for distribution.
                </p>
              </div>
              <div className="p-6" data-id="element-698" data-mp="2t6epblubg0mi">
                <div className="w-12 h-12 bg-gold-500/10 rounded-full flex items-center justify-center mx-auto mb-4 text-gold-500 font-bold text-xl" data-id="element-699" data-mp="2y2c2xke72svl">
                  3
                </div>
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-700" data-mp="337pbemo81ro9">
                  Spread the Word
                </h3>
                <p className="text-white/60 text-sm" data-id="element-701" data-mp="2yfxul3uvb0bb">
                  Share our mission with your church or community group.
                </p>
              </div>
            </div>

            <Link to="/donate" data-id="element-702" data-mp="2pgu7zpwhs2s2">
              <Button size="lg" className="shadow-xl shadow-gold-500/20" data-id="element-703" data-mp="2phvm638t15e0">
                Give to Operation Olive Branch
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </PageTransition>;
}